import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  title: {
    fontWeight: '600',
  },
  subTitle: {
    fontWeight: '500',
    fontSize: '0.75rem',
    marginTop: '0.5rem',
  },
  text: {
    marginTop: '16px',
    marginBottom: '0px',
    color: theme.colors.grey[650],
    fontSize: '14px',
    maxWidth: '90%',
    '& a': {
      color: theme.colors.primaryBlue[500],
    },
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '&:not(:first-of-type)': {
      marginTop: '32px',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 50%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flex: '0 0 100%',
      alignItems: 'center',
    },
  },
  fullblock: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: '0 0 100%',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
  },
  badges: {
    display: 'flex',
    marginTop: '16px',
    gap: '16px',
    '& > div': {
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    '& div': {
      opacity: '1',
    },
  },
}));

export default useStyles;